import { useState, useEffect } from "react";

// react-router-dom components
import { Link, useNavigate, useSearchParams } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useMediaQuery } from "react-responsive";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
// Images
import bgImage from "assets/images/backgroundLogin.png";
import bgImageMobile from "assets/images/backgroundLoginMobile.png";
import singhCoinBrand from "assets/images/singhCoinBrand.png";
import googleLoginLogo from "assets/images/googleLoginLogo.png";
import MDAvatar from "components/MDAvatar";
import validations from "customValidations/validations";
import validationService from "customValidations/validationService";
import { signIn } from "services/userService";
import {
  Divider,
  IconButton,
  InputAdornment,
  TextField,
  Stack,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import applestore from "assets/images/AppStore.png";
import googleplay from "assets/images/GooglePlay.png";

import { googleSignIn } from "services/userService";
import { toast } from "react-toastify";
import { useRef } from "react";
import { updateUser } from "services/apiService";

function SetupProfile() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const inputFile = useRef(null);
  const [name, setName] = useState("");
  const [bio, setBio] = useState("");
  const [userName, setUserName] = useState("");
  const [img, setImg] = useState("");
  const [imgSrc, setImgSrc] = useState("");

  const [errorMsg, setErrorMsg] = useState({
    name: { errorMsg: "" },
    userName: { errorMsg: "" },
    bio: { errorMsg: "" },
  });

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  // useEffect(() => {
  //   checkIfLoggedIn();
  // }, []);

  // const checkIfLoggedIn = () => {
  //   if (localStorage.jwtTokenSingh) {
  //     navigate("/");
  //   }
  // };

  const customValidations = (name, value) => {
    let errorLength = 0;
    const args = [
      {
        name,
        value: value,
        validations: validations.editProfileValidations[name],
      },
    ];

    validationService.validate(args, (validationErr, validationErrMsgs) => {
      if (validationErrMsgs.length > 0) {
        errorLength = errorLength + 1;
        errorMsg[name].errorMsg = validationErrMsgs[0].validations[0].message;
        setErrorMsg({ ...errorMsg });
      } else {
        errorMsg[name].errorMsg = "";
        setErrorMsg({ ...errorMsg });
      }
    });
    return errorLength;
  };

  const handleProfileClick = () => {
    inputFile.current.click();
  };

  const handleBrowse = (e) => {
    setImg(e.target.files[0]);
    var file = e.target.files[0];
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);

    reader.onloadend = function (e) {
      setImgSrc(reader.result);
    };
  };

  const handleInputChange = (name, value) => {
    if (name === "name") {
      setName(value);
    } else if (name === "bio") {
      setBio(value);
    } else if (name === "userName") {
      setUserName(value);
    } else {
      console.log("inputError");
    }
  };

  const handleSaveProfileData = async () => {
    let errorLengthName = customValidations("name", name);
    // let errorLengthUserName = customValidations("userName", userName);
    let errorLengthBio = customValidations("bio", bio);

    if (
      errorLengthName !== 1 &&
      // errorLengthUserName !== 1 &&
      errorLengthBio !== 1
    ) {
      // console.log("Alll okkkkkkk");
    } else {
      console.log("Validation error");
      return;
    }

    if (searchParams.get("google")) {
      let errorLengthUserName = customValidations("userName", userName);
      if (errorLengthUserName === 1) {
        return;
      }
    }

    let updateData = new FormData();

    updateData.append("fullName", name);
    updateData.append("username", userName);
    updateData.append("bio", bio);
    updateData.append("profile", img);

    const updateDataRes = await updateUser(updateData);

    // console.log("updateDataRes", updateDataRes);

    if (updateDataRes.status === 200) {
      toast.success(`Saved successfully`, {
        style: {
          fontSize: "15px",
        },
      });
      if (searchParams.get("google")) {
        localStorage.setItem("userNameSingh", userName);
      }
      navigate("/");
    }
    // else {
    //   toast.error(`Oops something went wrong, please try again`, {
    //     style: {
    //       fontSize: "15px",
    //     },
    //   });
    // }
  };

  return (
    <BasicLayout image={isDesktopOrLaptop ? bgImage : bgImageMobile}>
      <Card sx={{ backgroundColor: "#ebebeb", boxShadow: "none" }}>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox
            sx={{
              marginBottom: "2rem",
              display: "flex",
              flexDirection: "column",
              //   justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MDBox sx={{ marginBottom: "1rem" }}>
              <MDTypography color="text">Setup Your Profile</MDTypography>
            </MDBox>

            <MDInput
              style={{ display: "none" }}
              type="file"
              inputProps={{ ref: inputFile, accept: "image/*" }}
              onChange={(e) => handleBrowse(e)}
            />
            <MDAvatar
              src={imgSrc}
              sx={{
                position: "initial",
                top: isDesktopOrLaptop ? "35%" : "38%",
                left: isDesktopOrLaptop ? "45%" : "35%",
                height: isDesktopOrLaptop ? "140px" : "100px",
                width: isDesktopOrLaptop ? "140px" : "100px",
                cursor: "pointer",
                border: "1px dashed #000",
              }}
              imgProps={{ style: { height: "100%", width: "100%" } }}
              onClick={() => handleProfileClick()}
            ></MDAvatar>
            <IconButton
              sx={{
                alignItems: "end",
                position: "relative",
                fontSize: "45px",
                // top: isDesktopOrLaptop ? "36%" : "38%",
                left: isDesktopOrLaptop ? "15%" : "12%",
                height: isDesktopOrLaptop ? "15px" : "27px",
                // width: isDesktopOrLaptop ? "200px" : "100px",
                cursor: "pointer",
              }}
              onClick={() => handleProfileClick()}
              aria-label="add to favorites"
            >
              <CameraAltOutlinedIcon style={{ color: "#aeaeae" }} />
            </IconButton>
          </MDBox>
          <MDBox role="form">
            <MDBox mb={2}>
              <TextField
                fullWidth
                // type="email"
                name="name"
                label="Full Name"
                inputProps={{
                  style: { color: "#000000" },
                }}
                error={errorMsg.name.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={
                  errorMsg.name.errorMsg === ""
                    ? "Maximum 30 character"
                    : errorMsg.name.errorMsg
                }
              />
            </MDBox>

            {searchParams.get("google") && (
              <MDBox mb={2}>
                <TextField
                  fullWidth
                  // type="email"
                  name="userName"
                  label="Username"
                  inputProps={{
                    style: { color: "#000000" },
                  }}
                  error={errorMsg.userName.errorMsg.length > 0}
                  onChange={(e) =>
                    handleInputChange(e.target.name, e.target.value)
                  }
                  helperText={
                    errorMsg.userName.errorMsg === ""
                      ? "Maximum 30 character"
                      : errorMsg.userName.errorMsg
                  }
                />
              </MDBox>
            )}

            <MDBox mb={2}>
              <TextField
                fullWidth
                id="outlined-multiline-static"
                multiline
                rows={4}
                name="bio"
                label="Bio"
                inputProps={{
                  style: { color: "#000000" },
                }}
                error={errorMsg.bio.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={
                  errorMsg.bio.errorMsg === ""
                    ? "Maximum 180 character"
                    : errorMsg.bio.errorMsg
                }
              />
            </MDBox>

            <MDBox mt={4} mb={1}>
              <MDButton
                color="singh"
                fullWidth
                onClick={() => handleSaveProfileData()}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default SetupProfile;
